import React, { useEffect, useRef } from 'react';

import NavigableList from 'generics/components/navigable-list';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import {
  getFontWeightOptions
} from './utilities';

import './index.scss';

function FontWeightSelector(props) {

  const fontWeightSelectorMainReference = useRef(null);

  useEffect(function onLoad() {

    displayFontFamiliesMenu();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function displayFontFamiliesMenu() {

    const element = fontWeightSelectorMainReference.current;
    const anchorElement = element.parentNode;
    const viewportElement = void 0;
    const verticalOffset = 10;
    const horizontalOffset = 0;
    const startSide = 'bottom';
    const placeOnCenter = true;
    const positionableSides = void 0;

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  function renderFontWeight(item, index, selectedItemIndex) {

    const itemAttributes = {
      className: 'font-weight-item navigable-list-item ',
      style: {
        // fontWeight: item.value
      }
    };

    if (index === selectedItemIndex) {
      itemAttributes.className += ' selected';
    }

    return <div {...itemAttributes}>
      <span className="ellipsis">{item.name}</span>
    </div>;
  }

  function renderMain() {

    const mainAttributes = {
      id: 'font-weight-selector-main',
      ref: fontWeightSelectorMainReference
    };

    const fontWeights = getFontWeightOptions();

    const navigableListProperties = {
      items: fontWeights,
      selectedItemIndex: findIndexByPropertyValue(fontWeights, 'value', props.fontWeight),
      itemRenderer: renderFontWeight,
      noScroll: true,
      onSelect(item, event) {
        event.preventDefault();
        props.onChange(item);
        return false;
      }
    };

    return <div {...mainAttributes}>
      <NavigableList {...navigableListProperties} />
    </div>;

  }

  return renderMain();

}

export default FontWeightSelector;